import React from 'react';

function Footer() {
  return (
    <footer className="clean-footer crev">
      <div className="container pt-60 pb-40 ontop text-center">
        <div className="logo icon-img-100 mb-20" style={{ display: 'inline-block' }}>
          <img src="/assets/imgs/logo-light.png" alt="Hanzol" />
        </div>
        <p style={{ fontSize: '0.85rem', opacity: 0.6, margin: 0 }}>
          © 2026 Agência Hanzol — Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
